import { useState } from "react";
import styles from "./ServiceUnavailable.module.css";

/**
 *
 * @param {object}   props
 * @param {string}  [props.message]  Optional custom message from the admin.
 * @param {function} props.onRetry   Re-checks status; should resolve/return after the check.
 */
export default function ServiceUnavailable({ message, onRetry }) {
  const [checking, setChecking] = useState(false);

  const handleRetry = async () => {
    if (checking) return;
    setChecking(true);
    try {
      await onRetry?.();
    } finally {
      // If we're still mounted, maintenance is still on — let them try again.
      setChecking(false);
    }
  };

  return (
    <div className={styles.overlay} role="alert" aria-live="polite">
      <div className={styles.art} aria-hidden>🛠️</div>
      <h1 className={styles.title}>We&apos;ll be right back!</h1>
      <p className={styles.message}>
        {message ||
          "Read21 is taking a short break for some tune-ups. Please check back a little later — your progress is safe."}
      </p>
      <button
        type="button"
        className={styles.retry}
        onClick={handleRetry}
        disabled={checking}
      >
        {checking ? "Checking…" : "Try again"}
      </button>
      {checking && <div className={styles.checking}>Seeing if we&apos;re back online…</div>}
      <img src="/read21-logo.png" alt="Read21" className={styles.logo} />
    </div>
  );
}
